import {ChangeDetectorRef, Component, Inject, Input, OnInit, ViewEncapsulation} from '@angular/core'
import {QuestionModel} from '../../../core/model/question.model'
import {FormGroup} from '@angular/forms'
import {MatDialog} from '@angular/material'
import {QuestionDependencyDialogComponent} from './question-dependency-dialog.component'
import {FormComponent} from '../../form.component'
import {SectionModel} from '../../../core/model/section.model'
import {Possibility} from '../../../core/model/possiblity.model'
import {slideAnimation} from '../../../core/animation/slide'

@Component({
  selector: 'fe-dep',
  encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./question-dependency.component.scss'],
  template: `
    <fe-feature
      [label]="(''|m).condition_popupTitle"
      [isOpen]="pickedPossibility">
      <mat-slide-toggle
        feFeatureAction
        [checked]="isChecked"
        (change)="toggleDependency($event)">
      </mat-slide-toggle>

      <div *ngIf="pickedPossibility">
        <div (click)="seeMore = !seeMore" class="fe-dep_picked">
          <div class="fe-dep_picked_label">{{pickedPossibility.label}}</div>
          <button mat-icon-button class="fe-dep_picked_btn" (click)="open(); $event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div *ngIf="seeMore" class="fe-dep_picked_desc" [@slide]>
          <div class="fe-dep_picked_row">
            <div class="fe-dep_picked_row_label">{{(''|m).condition_relatedQuestion}}</div>
            <div class="fe-dep_picked_row_val">{{pickedQuestion.label}}</div>
          </div>
          <div class="fe-dep_picked_row">
            <div class="fe-dep_picked_row_label">{{(''|m).condition_relatedSection}}</div>
            <div class="fe-dep_picked_row_val">{{pickedSection.name}}</div>
          </div>
        </div>
      </div>
    </fe-feature>
  `,
  host: {'class': 'question_feature'},
  animations: [slideAnimation],
})
export class QuestionDependencyComponent implements OnInit {

  @Input() question: QuestionModel

  @Input() form: FormGroup

  pickedSection: SectionModel

  pickedQuestion: QuestionModel

  pickedPossibility: Possibility

  seeMore = false

  isChecked = false

  constructor(public dialog: MatDialog,
              @Inject(FormComponent) private $form: FormComponent,
              private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
    if (this.question.possibility_id_dep) this.fillSelection()
    const val = this.form.get('possibility_id_dep').value
    this.isChecked = val && val !== ''
  }

  toggleDependency(e: any) {
    e.checked ? this.open() : this.clear()
  }

  open() {
    this.isChecked = true
    const ref = this.dialog.open(QuestionDependencyDialogComponent, {width: '600px'})
    ref.componentInstance.question = this.question
    ref.componentInstance.form = this.form
    ref.componentInstance.$form = this.$form
    ref.componentInstance.selectedSection = this.pickedSection
    ref.componentInstance.selectedQuestion = this.pickedQuestion
    ref.afterClosed().subscribe(result => {
      if (result) {
        this.pickedSection = result.section
        this.pickedQuestion = result.question
        this.pickedPossibility = result.possibility
        this.form.patchValue({possibility_id_dep: this.pickedPossibility.id})
      } else {
        this.isChecked = false
      }
      this.cd.markForCheck()
    })
  }

  clear() {
    this.form.patchValue({possibility_id_dep: ''})
    this.pickedSection = null
    this.pickedQuestion = null
    this.pickedPossibility = null
  }

  private fillSelection() {
    this.$form.form.sections.every((s: SectionModel) =>
      s.questions.every((q: QuestionModel) =>
        q.possibilities.every((p: Possibility) => {
          if (p.id === this.question.possibility_id_dep) {
            this.pickedPossibility = p
            this.pickedQuestion = q
            this.pickedSection = s
            return false
          }
          return true
        })
      )
    )
    this.cd.markForCheck()
  }
}
